// Room configuration for Villa Savi
export const ROOMS = {
  "101": {
    id: "101",
    name: "Garden Room 101",
    type: "garden",
    description: "Nestled near the pool under tall pine trees, the Garden Rooms offer peace, privacy, and a soft connection to the villa's natural rhythm.",
    basePrice: 1200,
    images: [
      "https://static.wixstatic.com/media/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Garden view", "Near pool"]
  },
  "102": {
    id: "102",
    name: "Garden Room 102",
    type: "garden",
    description: "Nestled near the pool under tall pine trees, the Garden Rooms offer peace, privacy, and a soft connection to the villa's natural rhythm.",
    basePrice: 1200,
    images: [
      "https://static.wixstatic.com/media/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Garden view", "Near pool"]
  },
  "103": {
    id: "103",
    name: "Garden Room 103",
    type: "garden",
    description: "Nestled near the pool under tall pine trees, the Garden Rooms offer peace, privacy, and a soft connection to the villa's natural rhythm.",
    basePrice: 1200,
    images: [
      "https://static.wixstatic.com/media/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Garden view", "Near pool"]
  },
  "104": {
    id: "104",
    name: "Garden Room 104",
    type: "garden",
    description: "Nestled near the pool under tall pine trees, the Garden Rooms offer peace, privacy, and a soft connection to the villa's natural rhythm.",
    basePrice: 1200,
    images: [
      "https://static.wixstatic.com/media/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_a7112dc842e742219a0a65e143a4e71f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_5c9d290dc3a24769a660b1582425dae2~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_976b2224b57041bd9ca208b00fe0240a~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Garden view", "Near pool"]
  },
  "201": {
    id: "201",
    name: "Baylight Suite with Terrace",
    type: "suite",
    description: "Facing west toward the Mediterranean, this spacious suite includes a private sun terrace — perfect for slow evenings and longer stays.",
    basePrice: 1450,
    images: [
      "https://static.wixstatic.com/media/7c2ee1_b0736b78d4b947a8869ee52580cdb9b9~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_b0736b78d4b947a8869ee52580cdb9b9~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_07981c92215e43348ff67f4281c095c3~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_07981c92215e43348ff67f4281c095c3~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_1abfc85ca2c94057b6e565b376007368~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_1abfc85ca2c94057b6e565b376007368~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Private terrace", "Sea views", "Tatami bed"]
  },
  "202": {
    id: "202",
    name: "Private Double Room – Panorama",
    type: "double",
    description: "Located in the main house with sweeping views, this private double offers comfort, privacy, and space to recharge.",
    basePrice: 1350,
    images: [
      "https://static.wixstatic.com/media/447ef7_ad8ceeec2bf34d59b755b058a10b571b~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_ad8ceeec2bf34d59b755b058a10b571b~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_ea90f6ab15de4664816d5de6458226bf~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_ea90f6ab15de4664816d5de6458226bf~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Panoramic views", "Double bed"]
  },
  "203": {
    id: "203",
    name: "Large Panorama Suite",
    type: "suite",
    description: "Grounded and generous, the Large Suite has space to stretch, create, and rest. Ideal for couples or solo travelers planning a longer journey.",
    basePrice: 1700,
    images: [
      "https://static.wixstatic.com/media/447ef7_673917bb40a94da8984c32b86922e733~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_673917bb40a94da8984c32b86922e733~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_e127098284b145f2aa4b72abcb60599a~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_e127098284b145f2aa4b72abcb60599a~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_fdc7e16ad852445d89385944928c0401~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Large space", "Panoramic views", "Workspace"]
  },
  "205": {
    id: "205",
    name: "Sunny Apartment with Kitchen",
    type: "apartment",
    description: "Our largest private unit, complete with a kitchenette, study, bedroom, and balcony. Perfect for those who want autonomy while staying connected to the Savi community.",
    basePrice: 2100,
    images: [
      "https://static.wixstatic.com/media/447ef7_b7dcfc48e621473d82877917795cfd00~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_b7dcfc48e621473d82877917795cfd00~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_41d07f87c3c54bfaa4cc81ae2f58b20a~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_41d07f87c3c54bfaa4cc81ae2f58b20a~mv2.jpg",
      "https://static.wixstatic.com/media/447ef7_8ea767ca301943c497de41a6caf949e2~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/447ef7_8ea767ca301943c497de41a6caf949e2~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Private kitchen", "Balcony", "Study area"]
  },
  "301": {
    id: "301",
    name: "Sky Room 301 (Ensuite)",
    type: "sky",
    description: "Light-filled and minimal, with a private ensuite bathroom and access to the 200sqm Sky Terrace overlooking the valley, Valencia, and the Mediterranean.",
    basePrice: 1400,
    images: [
      "https://static.wixstatic.com/media/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg"
    ],
    amenities: ["Private ensuite bathroom", "Terrace access", "Mountain views"]
  },
  "302": {
    id: "302",
    name: "Sky Room 302",
    type: "sky",
    description: "Light-filled and minimal, with access to a large terrace and expansive views — perfect for solo guests who want to unwind, write, or simply be.",
    basePrice: 1300,
    images: [
      "https://static.wixstatic.com/media/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg"
    ],
    amenities: ["Shared bathroom", "Terrace access", "Mountain views"]
  },
  "303": {
    id: "303",
    name: "Sky Room 303",
    type: "sky",
    description: "Light-filled and minimal, with access to a large terrace and expansive views — perfect for solo guests who want to unwind, write, or simply be.",
    basePrice: 1300,
    images: [
      "https://static.wixstatic.com/media/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_8d05bd7580cd41aa92d3bb2254ff1d5d~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_12e3c0cc65064ab4ace03fbd4583e156~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_b9a13bb9d35d4a7db1f98931c66648f7~mv2.jpg"
    ],
    amenities: ["Shared bathroom", "Terrace access", "Mountain views"]
  },
  "304": {
    id: "304",
    name: "Private Double Room – Tower",
    type: "tower",
    description: "Perched at the very top of the villa, this private double has sweeping views and total privacy — a quiet retreat for couples or solo travelers.",
    basePrice: 1450,
    images: [
      "https://static.wixstatic.com/media/7c2ee1_5c38eba8232b4da9a42c9da01b2bd84f~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_5c38eba8232b4da9a42c9da01b2bd84f~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_ff67404917324fb59fdacf3fc7e18bd7~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_ff67404917324fb59fdacf3fc7e18bd7~mv2.jpg",
      "https://static.wixstatic.com/media/7c2ee1_53019ba4fa3f430985b30d812e937d25~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,enc_avif,quality_auto/7c2ee1_53019ba4fa3f430985b30d812e937d25~mv2.jpg"
    ],
    amenities: ["Private bathroom", "Top floor", "360° views", "Double bed"]
  }
};

// Room options for dropdown
export const ROOM_OPTIONS = [
  { value: "101", label: "101 - Garden Room", type: "garden" },
  { value: "102", label: "102 - Garden Room", type: "garden" },
  { value: "103", label: "103 - Garden Room", type: "garden" },
  { value: "104", label: "104 - Garden Room", type: "garden" },
  { value: "201", label: "201 - Baylight Suite with Terrace", type: "suite" },
  { value: "202", label: "202 - Private Double Room – Panorama", type: "double" },
  { value: "203", label: "203 - Large Panorama Suite", type: "suite" },
  { value: "205", label: "205 - Sunny Apartment with Kitchen", type: "apartment" },
  { value: "301", label: "301 - Sky Room", type: "sky" },
  { value: "302", label: "302 - Sky Room", type: "sky" },
  { value: "303", label: "303 - Sky Room", type: "sky" },
  { value: "304", label: "304 - Private Double Room – Tower", type: "tower" }
];

// FAQ data
export const FAQ_DATA = [
  {
    question: "Will I have privacy?",
    answer: "Absolutely! You will have your own private room, and there are plenty of cozy spots around the property where you can enjoy some quiet time or relax. We value your privacy while also fostering community!"
  },
  {
    question: "Are pets allowed?",
    answer: "We love pets and would be happy to welcome yours! To ensure a comfortable experience for everyone, we just need to discuss your pet's size and type with other guests. Please let us know more about your furry friend!"
  },
  {
    question: "Can I split the rent with my partner or a friend?",
    answer: "We allow couples and friends to stay in our bigger rooms, ensuring plenty of space for your needs and comfort. Please be advised that extra fees may apply."
  },
  {
    question: "Is there a designated space for work?",
    answer: "You have plenty of flexible workspace options to suit your mood and your requirements for the day. We also have an area we call \"Biblioteca\" which means Library in Spanish dedicated for comfortable co-working."
  },
  {
    question: "What types of people will I be sharing the home with?",
    answer: "Digital nomads and world travellers seeking conscious coliving, well-being, and a peaceful retreat in nature — all while being just 30 minutes from the beach and 40 minutes from Valencia city centre."
  },
  {
    question: "Will I get the same room as on the photos?",
    answer: "The room you will be assigned might differ slightly from the photos but will match the room type. You are booking a room/bed by type, not a specific unit."
  },
  {
    question: "Can I extend or shorten my stay?",
    answer: "Yes, you can definitely extend or shorten your stay if it is possible! We just ask that you let us know in advance so we can assist you with the changes."
  },
  {
    question: "Do I need to sign a contract/lease?",
    answer: "Yes, signing a contract or lease is necessary as per local regulations. This helps ensure a smooth living experience and protects everyone involved."
  },
  {
    question: "What is the cancellation policy?",
    answer: "Before 30 days of arrival: Cancellations are free, fully refundable. Within 30 days of arrival: Non-refundable, but guests may move their dates one time within the next three months if availability allows."
  },
  {
    question: "What's included in my stay?",
    answer: "Private bathroom (some rooms shared), natural light & views, ultra-fast Starlink Wi-Fi, weekly cleaning service, sheets, pillows & fresh towels, lockable door for privacy, and quiet hours after 10pm."
  }
];
